<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Monthly Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <router-link to="/payout">Payout Report</router-link> /
      <b>Add Invoice Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              <b>Report Invoice Upload</b>
            </h4>

            <p>Fill in the information</p>

            <form class="form" @submit.prevent="handleSubmit">
              <div class="form-group">
                <label>Month of Invoice</label>
                <input class="form-control" v-model="month" disabled />
              </div>

              <div class="form-group">
                <label>Upload Invoice </label> <br />

                <span v-if="payout.invoice_url != null">
                  <b>*Your invoice for this month has already been uploaded</b>
                </span>

                <br />

                <small class="text-danger">
                  (Please upload PDF file only)</small
                >
                <input
                  type="file"
                  id="file"
                  ref="invoice_upload"
                  class="form-control"
                  @change="handleFileUpload()"
                />
                <br />
              </div>

              <input type="submit" class="btn btn-primary" value="Upload" />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "banner_new",

  data() {
    return {
      month: "",
      invoice_upload: "",
      payout: [],
    };
  },

  methods: {
    loadData() {
      let month = this.$route.params.month;

      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      this.month = months[month - 1];

      let token = localStorage.getItem("token");

      let payout_id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/payout/" + payout_id, {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((res) => {
            if (!res.data.success) {
              swal({
                icon: "danger",
                title: "Error",
                text: "You are not authorized user",
              }).then((ok) => {
                this.$router.push("/login");
                localStorage.clear();
              });
            } else {
              this.payout = res.data.payout;
            }
          });
      }
    },

    handleFileUpload() {
      this.invoice_upload = this.$refs.invoice_upload.files[0];
    },

    handleSubmit() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;

      let formdata = new FormData();

      formdata.append("id", id);
      formdata.append("invoice_upload", this.invoice_upload);

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"],
        }).then((confirm) => {
          if (!confirm) {
            return;
          }

          axios
            .post(axios.lpsURL + "/payout/upload", formdata, {
              headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (res.data.success) {
                swal({
                  icon: "success",
                  title: "Success",
                  text: res.data.message,
                });
              } else {
                swal({
                  icon: "error",
                  title: "Failed",
                  text: res.data.message,
                });
              }
            });
        });
      }
    },
  },

  mounted() {
    this.loadData();
  },
};
</script>

